import { Component, Input, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
	selector: 'app-cig-what-next',
	templateUrl: './cig-what-next.component.html',
	styleUrls: ['./cig-what-next.component.scss']
})
export class CigWhatNextComponent implements OnInit {
	@Input() slides;
	@Input() author;
	public env;
	constructor() { }

	ngOnInit() {
		this.env=environment;
	}

}
